<template>
  <div class="app-detail-page" v-if="info.id" v-loading="pageLoading">
    <div class="detail-header">
      <div class="detail-header__main">
        <h2>{{ info.app_name || info.app_code }}</h2>
        <p>{{ info.app_code }}</p>
      </div>
      <div class="detail-header__meta">
        <el-tag :type="Number(info.status) === 1 ? 'success' : 'info'">
          {{ Number(info.status) === 1 ? "启用" : "禁用" }}
        </el-tag>
        <el-tag effect="plain">版本号：{{ configForm.version || "--" }}</el-tag>
      </div>
    </div>

    <el-tabs v-model="activeTab">
      <el-tab-pane label="基础信息" name="base">
        <el-card shadow="never" class="detail-card">
          <el-form
            ref="baseFormRef"
            class="mobile-stack-form"
            :model="baseForm"
            :rules="baseRules"
            label-width="110px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="应用名称" prop="app_name">
                  <el-input v-model.trim="baseForm.app_name" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="应用编码">
                  <el-input v-model="baseForm.app_code" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="包名">
                  <el-input v-model.trim="baseForm.package_name" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态" prop="status">
                  <el-switch
                    v-if="$store.getters.isSuperAdmin"
                    v-model="baseForm.status"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="启用"
                    inactive-text="禁用"
                  />
                  <el-tag
                    v-else
                    :type="Number(baseForm.status) === 1 ? 'success' : 'info'"
                  >
                    {{ Number(baseForm.status) === 1 ? "启用" : "禁用" }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input
                    v-model.trim="baseForm.remark"
                    type="textarea"
                    :rows="3"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="detail-actions">
            <el-button type="primary" :loading="baseSaving" @click="saveBase">
              保存基础信息
            </el-button>
          </div>
        </el-card>
      </el-tab-pane>

      <el-tab-pane label="APP配置" name="config">
        <el-card shadow="never" class="detail-card">
          <el-form
            ref="configFormRef"
            class="mobile-stack-form"
            :model="configForm"
            label-width="120px"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="微信 Secret">
                  <el-input v-model.trim="configForm.wx_appSecret" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="微信 AppId">
                  <el-input v-model.trim="configForm.wx_appid" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="版本号(versionCode)">
                  <el-input
                    v-model.trim="configForm.version"
                    type="number"
                    placeholder="请输入纯数字 versionCode"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="奖励比例">
                  <el-input v-model.trim="configForm.amount_number" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="APK 下载地址">
                  <el-input
                    v-model.trim="configForm.apk_url"
                    placeholder="请输入 APK 下载地址"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="安全密钥">
                  <el-input v-model.trim="configForm.appSecurityKey" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="信息流ID">
                  <el-input v-model.trim="configForm.info_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="插屏ID">
                  <el-input v-model.trim="configForm.interstitial_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开屏ID">
                  <el-input v-model.trim="configForm.splash_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="激励ID">
                  <el-input v-model.trim="configForm.reward_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="激励名称">
                  <el-input v-model.trim="configForm.reward_name" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Banner ID">
                  <el-input v-model.trim="configForm.banner_id" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Taku Key">
                  <el-input v-model.trim="configForm.taku_key" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Taku AppId">
                  <el-input v-model.trim="configForm.taku_app_id" />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="ECPM Client Key">
                  <el-input
                    v-model="configForm.ecpm_key"
                    type="textarea"
                    :rows="4"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="ECPM Server Key">
                  <el-input
                    v-model="configForm.ecpm_key2"
                    type="textarea"
                    :rows="4"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="马甲包广告">
                  <el-switch
                    v-model="configForm.open_vest_package_ad"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="开启"
                    inactive-text="关闭"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="提现入口">
                  <el-select v-model="configForm.open_withdraw" style="width: 100%">
                    <el-option label="开启" value="1" />
                    <el-option label="关闭" value="0" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="提现方式">
                  <el-select
                    v-model="configForm.withdraw_type"
                    multiple
                    style="width: 100%"
                    placeholder="请选择提现方式"
                  >
                    <el-option label="支付宝" value="0" />
                    <el-option label="微信" value="1" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="提现金额表">
                  <el-button type="primary" plain @click="openAmountOptionDialog">
                    配置 APP 金额档位
                  </el-button>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="配置 JSON">
                  <el-input
                    v-model.trim="configForm.app_config_json"
                    type="textarea"
                    :rows="5"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="detail-actions">
            <el-button type="primary" :loading="configSaving" @click="saveConfig">
              保存 APP 配置
            </el-button>
          </div>
        </el-card>
      </el-tab-pane>

    </el-tabs>

    <el-dialog
      title="APP 提现金额档位"
      :visible.sync="amountOptionDialogVisible"
      width="760px"
      @open="loadAmountOptions"
      @closed="resetAmountOptionForm"
    >
      <el-form
        ref="amountOptionFormRef"
        :model="amountOptionForm"
        label-width="110px"
        size="small"
      >
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="金额（元）">
              <el-input
                v-model.trim="amountOptionForm.amount_yuan"
                type="number"
                placeholder="例：1.00"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目单位">
              <el-input
                v-model.trim="amountOptionForm.money"
                type="number"
                placeholder="100000 = 1元"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排序">
              <el-input-number
                v-model="amountOptionForm.sort"
                :min="0"
                :max="9999"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-select v-model="amountOptionForm.status" style="width: 100%">
                <el-option label="启用" value="1" />
                <el-option label="停用" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label=" ">
              <el-button type="primary" :loading="amountOptionSaving" @click="saveAmountOption">
                {{ editingAmountOption ? "保存档位" : "新增档位" }}
              </el-button>
              <el-button @click="resetAmountOptionForm">清空</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table
        v-if="!isMobileViewport"
        :data="amountOptions"
        border
        stripe
        v-loading="amountOptionLoading"
        empty-text="暂无金额档位"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="金额" min-width="160">
          <template slot-scope="{ row }">
            {{ formatAmountOption(row) }}
          </template>
        </el-table-column>
        <el-table-column prop="money" label="项目单位" min-width="140" />
        <el-table-column prop="sort" label="排序" width="90" align="center" />
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="String(row.status) === '1' ? 'success' : 'info'">
              {{ String(row.status) === "1" ? "启用" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :width="isMobileViewport ? 76 : 170"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <responsive-actions
              :items="amountOptionRowActions"
              @select="handleAmountOptionRowAction($event, row)"
            />
          </template>
        </el-table-column>
      </el-table>
      <mobile-record-list
        v-else
        :rows="amountOptions"
        :loading="amountOptionLoading"
        :title="getMobileAmountTitle"
        :subtitle="getMobileAmountSubtitle"
        :fields="mobileAmountOptionFields"
        :actions="amountOptionRowActions"
        @action="handleAmountOptionRowAction"
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="amountOptionDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";

const createConfigForm = () => ({
  app_id: "",
  app_code: "",
  wx_appSecret: "",
  wx_appid: "",
  version: "",
  amount_number: "",
  apk_url: "",
  appSecurityKey: "",
  info_id: "",
  interstitial_id: "",
  splash_id: "",
  reward_id: "",
  reward_name: "",
  banner_id: "",
  taku_key: "",
  taku_app_id: "",
  ecpm_key: "",
  ecpm_key2: "",
  open_vest_package_ad: 0,
  open_withdraw: "0",
  withdraw_type: [],
  app_config_json: "",
});


const createAmountOptionForm = (appId = "") => ({
  id: "",
  app_id: appId,
  amount_yuan: "",
  money: "",
  sort: 0,
  status: "1",
});

export default {
  mixins: [responsiveMixin],
  computed: {
    amountOptionRowActions() {
      return [
        { key: "edit", label: "编辑", type: "primary" },
        { key: "delete", label: "删除", type: "danger" },
      ];
    },
    mobileAmountOptionFields() {
      return [
        { label: "金额", value: (row) => this.formatAmountOption(row) },
        { label: "项目单位", key: "money" },
        { label: "排序", key: "sort" },
        {
          label: "状态",
          value: (row) => (String(row.status) === "1" ? "启用" : "停用"),
          tag: true,
          tagType: (row) => (String(row.status) === "1" ? "success" : "info"),
        },
        { label: "档位ID", key: "id", summary: false },
      ];
    },
  },
  data() {
    return {
      activeTab: "base",
      pageLoading: false,
      baseSaving: false,
      configSaving: false,
      amountOptionLoading: false,
      amountOptionSaving: false,
      amountOptionDialogVisible: false,
      editingAmountOption: false,
      info: {},
      baseForm: {
        id: "",
        app_name: "",
        app_code: "",
        package_name: "",
        status: 1,
        remark: "",
      },
      configForm: createConfigForm(),
      amountOptions: [],
      amountOptionForm: createAmountOptionForm(),
      baseRules: {
        app_name: [{ required: true, message: "请输入应用名称", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  methods: {
    getMobileAmountTitle(row) {
      return this.formatAmountOption(row);
    },
    getMobileAmountSubtitle(row) {
      return `档位ID ${row.id}`;
    },
    handleAmountOptionRowAction(key, row) {
      if (key === "edit") this.editAmountOption(row);
      if (key === "delete") this.deleteAmountOption(row);
    },
    fillForms(data = {}) {
      const config = data.app_config || {};
      this.info = data;
      this.baseForm = {
        id: data.id || "",
        app_name: data.app_name || "",
        app_code: data.app_code || "",
        package_name: data.package_name || "",
        status: Number(data.status ?? 1),
        remark: data.remark || "",
      };
      this.configForm = {
        app_id: data.id || "",
        app_code: data.app_code || "",
        wx_appSecret: config.wx_appSecret || "",
        wx_appid: config.wx_appid || "",
        version: config.version || "",
        amount_number: config.amount_number || "",
        apk_url: config.apk_url || "",
        appSecurityKey: config.appSecurityKey || "",
        info_id: config.info_id || "",
        interstitial_id: config.interstitial_id || "",
        splash_id: config.splash_id || "",
        reward_id: config.reward_id || "",
        reward_name: config.reward_name || "",
        banner_id: config.banner_id || "",
        taku_key: config.taku_key || "",
        taku_app_id: config.taku_app_id || "",
        ecpm_key: config.ecpm_key || "",
        ecpm_key2: config.ecpm_key2 || "",
        open_vest_package_ad: Number(config.open_vest_package_ad || 0),
        open_withdraw: config.open_withdraw !== undefined && config.open_withdraw !== null
          ? String(config.open_withdraw)
          : "0",
        withdraw_type:
          config.withdraw_type !== undefined &&
          config.withdraw_type !== null &&
          config.withdraw_type !== ""
            ? String(config.withdraw_type)
                .split("@")
                .filter(Boolean)
            : [],
        app_config_json: config.app_config_json || "",
      };
    },
    async getInfo() {
      const id = this.$route.query.id;
      if (!id) {
        return;
      }

      this.pageLoading = true;
      try {
        const appRes = await this.$api.getApp.getAppInfo({ id });
        this.fillForms(appRes.data || {});
      } finally {
        this.pageLoading = false;
      }
    },
    formatAmountOption(row) {
      if (row.amount_yuan !== undefined && row.amount_yuan !== null && row.amount_yuan !== "") {
        return `${Number(row.amount_yuan).toFixed(2)} 元`;
      }
      return `${(Number(row.money || 0) / 100000).toFixed(2)} 元`;
    },
    openAmountOptionDialog() {
      this.amountOptionDialogVisible = true;
    },
    async loadAmountOptions() {
      if (!this.baseForm.id) {
        return;
      }

      this.amountOptionLoading = true;
      try {
        const data = await this.$api.getPayouts.getMoneyList({
          app_id: this.baseForm.id,
        });
        this.amountOptions = Array.isArray(data.data) ? data.data : [];
      } finally {
        this.amountOptionLoading = false;
      }
    },
    editAmountOption(row) {
      this.editingAmountOption = true;
      this.amountOptionForm = {
        ...createAmountOptionForm(this.baseForm.id),
        ...row,
        amount_yuan:
          row.amount_yuan !== undefined && row.amount_yuan !== null
            ? String(row.amount_yuan)
            : "",
        money:
          row.money !== undefined && row.money !== null
            ? String(Number(row.money).toFixed(0))
            : "",
        sort: Number(row.sort || row.index || 0),
        status: row.status === undefined || row.status === null ? "1" : String(row.status),
      };
    },
    resetAmountOptionForm() {
      this.editingAmountOption = false;
      this.amountOptionForm = createAmountOptionForm(this.baseForm.id);
    },
    async saveAmountOption() {
      const amountYuan = this.amountOptionForm.amount_yuan !== ""
        ? Number(this.amountOptionForm.amount_yuan)
        : 0;
      const rawMoney = amountYuan > 0
        ? Math.floor(amountYuan * 100000)
        : Math.floor(Number(this.amountOptionForm.money || 0));

      if (!rawMoney || rawMoney <= 0) {
        this.$message.warning("请输入提现金额");
        return;
      }

      this.amountOptionSaving = true;
      try {
        const payload = {
          id: this.amountOptionForm.id,
          app_id: this.baseForm.id,
          money: rawMoney,
          amount_yuan: (rawMoney / 100000).toFixed(2),
          sort: this.amountOptionForm.sort,
          status: this.amountOptionForm.status,
        };
        const data = this.editingAmountOption
          ? await this.$api.getPayouts.postSaveMoney(payload)
          : await this.$api.getPayouts.postAddMoney(payload);
        if (data.code === 200) {
          this.$message.success(this.editingAmountOption ? "金额档位已保存" : "金额档位已新增");
          this.resetAmountOptionForm();
          await this.loadAmountOptions();
        }
      } finally {
        this.amountOptionSaving = false;
      }
    },
    deleteAmountOption(row) {
      this.$confirm(`确认删除 ${this.formatAmountOption(row)} 档位吗？`, "删除金额档位", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const data = await this.$api.getPayouts.delMoney({ id: row.id });
          if (data.code === 200) {
            this.$message.success("金额档位已删除");
            await this.loadAmountOptions();
          }
        })
        .catch(() => {});
    },
    async saveBase() {
      const valid = await new Promise((resolve) => {
        this.$refs.baseFormRef.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.baseSaving = true;
      try {
        const data = await this.$api.getApp.postSaveAppInfo({
          ...this.baseForm,
          status: Number(this.baseForm.status),
        });
        if (data.code === 200) {
          this.$message.success("基础信息保存成功");
          this.getInfo();
          this.$store.dispatch("getAppList");
        }
      } finally {
        this.baseSaving = false;
      }
    },
    async saveConfig() {
      this.configSaving = true;
      try {
        const data = await this.$api.getApp.postSaveAppConfig({
          ...this.configForm,
          app_id: this.baseForm.id,
          app_code: this.baseForm.app_code,
          open_vest_package_ad: Number(this.configForm.open_vest_package_ad),
          withdraw_type: Array.isArray(this.configForm.withdraw_type)
            ? this.configForm.withdraw_type.join("@")
            : "",
        });
        if (data.code === 200) {
          this.$message.success("APP 配置保存成功");
          this.getInfo();
        }
      } finally {
        this.configSaving = false;
      }
    },
  },
  created() {
    this.getInfo();
  },
};
</script>

<style lang="less" scoped>
.detail-header {
  margin-bottom: 18px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 18px;
  background: linear-gradient(135deg, #f7fbff, #eef5ff);
  border: 1px solid #dde8f8;
}

.detail-header__main {
  h2 {
    margin: 0;
    color: #203864;
    font-size: 24px;
  }

  p {
    margin: 8px 0 0;
    color: #7a8da9;
  }
}

.detail-header__meta {
  display: flex;
  gap: 10px;
}

.detail-card {
  border-radius: 18px;
}

.detail-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}


@media (max-width: 768px) {
  .detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
</style>
